// App-level providers: TanStack Query + (optionally) TanStack Router. Kept a
// single thin wrapper so tests can render a subtree with just the QueryClient
// provider when they don't need the router.
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'

export function AppProviders({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // The gateway ops dashboard is a live status board; we want fresh
            // data on refocus but not aggressive background refetching beyond
            // the per-hook refetchInterval settings.
            refetchOnWindowFocus: true,
            retry: 1,
          },
        },
      }),
  )
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
